import { showNotify } from "../../helpers/toast";
import { PageBaseStatus } from "../../models/pageBaseStatus";
import { DotDangKyDichVuActionTypeIds, DotDangKyDichVuActionTypes } from "../action-types/dotDangKyDichVuActionTypes";
import { DotDangKyDichVuPageState } from "../page-state-model/dotDangKyDichVuPageState";
const initialState: DotDangKyDichVuPageState = {
    sf_dotdangky_dichvus: [],
    sf_dotdangky_dichvu_selected_id: 0,
    status: PageBaseStatus.is_completed
}
export const dotDangKyDichVuReducer = (state: DotDangKyDichVuPageState = initialState, action: DotDangKyDichVuActionTypes): DotDangKyDichVuPageState => {
    switch (action.type) {
        case DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_LOAD_START:
            return {
                ...state,
                status: PageBaseStatus.is_loading
            }
        case DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_LOAD_SUCCESS:
            return {
                ...state,
                status: PageBaseStatus.is_completed,
                sf_dotdangky_dichvus: action.payload
            }
        case DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_LOAD_ERROR:
            showNotify({ message: action.payload, type: "error" })
            return {
                ...state,
                status: PageBaseStatus.is_completed,
            }
        case DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_SHOW_DETAIL_MODAL:
            return {
                ...state,
                is_show_detail_modal: true,
                sf_dotdangky_dichvu_editing: action.payload
            }
        case DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_CLOSE_DETAIL_MODAL:
            return {
                ...state,
                is_show_detail_modal: false,
                // sf_hinhthucmiengiam_editing: undefined
            }
        case DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_SHOW_DELETE_CONFIRM:
            console.log(action.payload);
            return {
                ...state,
                is_show_delete_confirm: true
            }
        case DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_SAVE_START:
            return {
                ...state,
                status: PageBaseStatus.is_saving
            }
        case DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_SAVE_SUCCESS:
            showNotify({
                message: `${action.payload.id > 0 ? "Cập nhật " : "Thêm mới "} thành công đợt đăng ký dịch vụ ${action.payload.dot_dang_ky}`,
                type: "success"
            })
            return {
                ...state,
                status: PageBaseStatus.is_completed,
                sf_dotdangky_dichvu_editing: undefined,
                is_show_detail_modal: false
            }
        case DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_SAVE_ERROR:
            showNotify({ message: action.payload, type: "error" })
            return {
                ...state,
                status: PageBaseStatus.is_completed,
            }

        case DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_DELETE_START:
            return {
                ...state,
                status: PageBaseStatus.is_deleting
            }
        case DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_DELETE_SUCCESSS:
            showNotify({ message: `Xóa thành công đợt đăng ký dịch vụ`, type: "success" })
            return {
                ...state,
                status: PageBaseStatus.is_completed,
                is_show_delete_confirm: false
            }
        case DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_DELETE_ERROR:
            showNotify({ message: action.payload, type: "error" })
            return {
                ...state,
                is_show_delete_confirm: false,
                status: PageBaseStatus.is_completed
            }
        case DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_CHANGE_SELECTED_ID:
            return {
                ...state,
                sf_dotdangky_dichvu_selected_id: action.payload,
                is_show_delete_confirm: true
            }
        default:
            return state;
    }
}